
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacRadio extends Vue {
  @Prop({ default: false }) after!: boolean
  @Prop({ default: '' }) picked!: string;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '' }) name!: string;
  @Prop({ default: false }) deselectable!: boolean
  @Prop({ default: true }) showSymbol!: boolean

  pickedInternal = this.picked

  onInput (event: Event) {
    this.$emit('input', event)
  }
}
